<template>
  <Popup :centered="true" v-model="val" :closable="!immortalError">
    <h2 class="popup__title" v-html="title"></h2>
    <p class="popup__text" v-if="text" v-html="text"></p>
    <Btn class="popup__btn" v-if="!immortalError" @click.prevent.stop.native="type == 'repeat'? $store.dispatch('sendForm'):$store.commit('setError', false)">{{ btn }}</Btn>
  </Popup>
</template>

<script>
import { mapState } from 'vuex'
import Popup from './Popup.vue'
import Btn from './ui/Btn.vue'
import { mapFields } from 'vuex-map-fields'

export default {
  components: { Popup, Btn },
  props: {
    value: Boolean
  },
  computed: {
    ...mapState(['immortalError']),
    ...mapFields([
      'errorPopup.title',
      'errorPopup.text',
      'errorPopup.btn',
      'errorPopup.type'
    ]),    
    val: {
      get () { return this.value },
      set (value) { this.$emit('input', value);},
    },
  }
}
</script>

<style lang="sass">

</style>